<script setup>
// ============================================================================
// BonBoZ: vo chung cho cac trang co menu con (Cai dat, Bao cao).
//
// Khung hai cot cua Pancake — pancake-settings-ui-reference.md §1: menu trai
// co dinh 280px, cot phai cuon, than nen #ECEDF4 padding 32px, khoi noi dung
// rong 936px can giua.
//
// Tach ra thanh file rieng vi ca hai trang phai giong het nhau. Chep markup
// sang ca hai la mo duong cho chung lech nhau sau lan sua vo tiep theo.
//
// KHONG co header 75px cua Pancake o day, du reference §1 co. Chatwoot da ve
// tieu de BEN TRONG tung trang roi — 22 trang Cai dat dung `BaseSettingsHeader`,
// moi trang Bao cao dung `ReportHeader`. Them header o vo nua la tieu de hien
// hai lan. Gop hai cai lam mot phai sua 22+ trang, khong thuoc MVP1.
// ============================================================================
import MenuTrangCon from 'dashboard/components/SubPageMenu.vue';
import { useRoute } from 'vue-router';

defineProps({
  muc: { type: Array, required: true },
  tieuDe: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
});

const route = useRoute();
</script>

<template>
  <!-- Duoi 768px xep DOC: menu thanh dai ngang o tren, noi dung chiem tron be
       ngang. Giu hai cot thi menu 280px an mat gan het man dien thoai — do duoc
       09/09/2026: con 110px cho noi dung o man 390px, 80px o man 360px, chu be
       doc tung tu. Xem `SubPageMenu.vue`. -->
  <div
    class="flex flex-col md:flex-row w-full h-full m-0 overflow-hidden bg-[rgb(var(--pk-noi-dung-nen))]"
  >
    <MenuTrangCon :muc="muc" :tieu-de="tieuDe" />
    <div class="flex-1 min-h-0 overflow-auto p-4 md:p-8">
      <div class="w-full max-w-[936px] mx-auto">
        <router-view v-slot="{ Component }">
          <keep-alive v-if="keepAlive">
            <component :is="Component" :key="route.fullPath" />
          </keep-alive>
          <component :is="Component" v-else :key="route.fullPath" />
        </router-view>
      </div>
    </div>
  </div>
</template>
